import { Box, Heading, TextBlock } from "@bcc-ui/ui-components";
import { t } from "i18next";
import React from "react";

import style from "./tenant-settings-form.scss";
import CopyToClipboard from "components/copy-to-clipboard/CopyToClipboard";
import { Tenant } from "domain/tenants";

import testIds from "testIds.json";

interface Props {
    tenant: Tenant;
}

interface RowProps {
    label: string;
    children: React.ReactNode;
}

const Row = (props: RowProps) => (
    <Box className={style.row}>
        <strong>{props.label}</strong>
        <Box verticalAlignment="Center" className={style.rowContent}>
            {props.children}
        </Box>
    </Box>
);

export const TenantSettingsForm = (props: Props) => {
    return (
        <Box columnLayout gap="Lg" className={style.formContent}>
            <Box columnLayout>
                <Heading variant="h2" underline>
                    {t("CustomerProfile.erasureClientSettings")}
                </Heading>

                <Row label={t("CustomerProfile.endpoint")}>
                    <TextBlock disableBottomSpacing testId={testIds.workArea.settings.my.erasureClient.endpointLabel}>
                        {props.tenant.erasureClientEndpoint}
                    </TextBlock>
                    <CopyToClipboard value={props.tenant.erasureClientEndpoint} isNewTable />
                </Row>

                <Row label={t("Common.port")}>
                    <TextBlock disableBottomSpacing testId={testIds.workArea.settings.my.erasureClient.portLabel}>
                        {443}
                    </TextBlock>
                </Row>
            </Box>

            <Box columnLayout>
                <Heading variant="h2" underline>
                    {t("UserProfile.publicApiSettings")}
                </Heading>

                <Row label={t("CustomerProfile.endpoint")}>
                    <TextBlock disableBottomSpacing testId={testIds.workArea.settings.my.publicApi.endpointLabel}>
                        {props.tenant.publicApiEndpoint}
                    </TextBlock>
                    <CopyToClipboard value={props.tenant.publicApiEndpoint} isNewTable />
                </Row>

                <Row label={t("Common.port")}>
                    <TextBlock disableBottomSpacing testId={testIds.workArea.settings.my.publicApi.portLabel}>
                        {443}
                    </TextBlock>
                </Row>
            </Box>
        </Box>
    );
};
